import { defineMessages } from "react-intl";

import { DisplayType } from "@app/scene/home/enum/DisplayType";

import { GroupByType } from "./enum/GroupByType";

export const generalMessages = defineMessages({
  menuItem2: {
    id: "home.cards.engagement.menu.item2",
    defaultMessage: "Select record types",
    description: "Engagement Card menu item 2",
  },
  recordTypesDialogTitle: {
    id: "home.cards.engagement.selectRecordTypesDialog.title",
    defaultMessage: "Select Record Types",
    description: "Title for select Record types dialog",
  },
  title: {
    id: "home.cards.engagement.title",
    defaultMessage: "Records past due",
    description: "Engagement Card Title",
  },
});

export const groupByMessages = defineMessages<GroupByType>({
  [GroupByType.GROUP]: {
    id: "home.cards.engagement.menu.groupBy.groups",
    defaultMessage: "Select groups",
    description: "Engagement Card menu group by Groups",
  },
  [GroupByType.TEAM]: {
    id: "home.cards.engagement.menu.groupBy.teams",
    defaultMessage: "Select teams",
    description: "Engagement Card menu group by Teams",
  },
  [GroupByType.USER]: {
    id: "home.cards.engagement.menu.groupBy.users",
    defaultMessage: "Select users",
    description: "Engagement Card menu group by Users",
  },
});

export const displayTypeMessages = defineMessages<DisplayType>({
  [DisplayType.GROSS]: {
    id: "home.cards.engagement.menu.item3.gross",
    defaultMessage: "Switch to %",
    description: "Engagement Card menu item 3 switch to Gross",
  },
  [DisplayType.PERCENT]: {
    id: "home.cards.engagement.menu.item3.percent",
    defaultMessage: "Switch to gross number",
    description: "Engagement Card menu item 3 switch to Percent",
  },
});
